<template>
  <div class="navbar_wrap hidden-xs-only" :style="{ top: fixedBoxTop }">
    <div class="navbar_container">
      <!-- Logo区域 -->
      <div class="nav_left" @click="handleSelect('/')">
        <img src="@/assets/img/navigate/logo.png" alt="LOGO">
      </div>

      <!-- 自定义菜单区域 -->
      <div class="nav_right">
        <nav class="custom_menu">
          <ul class="menu_list">
            <li
              v-for="(router, index) in routes"
              :key="index"
              class="menu_item"
              :class="{ 'has_submenu': router.children && router.children.length }"
              @mouseenter="handleMenuMouseEnter(index)"
              @mouseleave="handleMenuMouseLeave"
            >
              <!-- 一级菜单项 -->
              <a
                :href="router.path"
                class="menu_link"
                :class="{ 'active': isActiveRoute(router.path) }"
                @click.prevent="handleSelect(router.path)"
              >
                {{ getMenuTitle(router) }}
              </a>

              <!-- 二级菜单下拉框 -->
              <div
                v-if="router.children && router.children.length && activeSubmenu === index"
                class="submenu_dropdown"
                :class="{ 'is-open': submenuVisible }"
                @mouseenter="handleSubmenuMouseEnter"
                @mouseleave="handleSubmenuMouseLeave"
              >
                <!-- 抽屉动画中间层 -->
                <div class="submenu_drawer" :class="{ 'is-open': submenuVisible }">
                  <ul class="submenu_list">
                    <li
                      v-for="(childItem, childIndex) in router.children"
                      :key="childIndex"
                      class="submenu_item"
                    >
                      <a
                        :href="childItem.path"
                        class="submenu_link"
                        :class="{ 'active': isActiveRoute(childItem.path) }"
                        @click.prevent="handleSelect(childItem.path)"
                      >
                        {{ getMenuTitle(childItem) }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
          </ul>
        </nav>

        <!-- 搜索图标 -->
        <div class="right_search" @click="handleSearch">
          <img src="../../assets/img/navigate/search.png" alt="全局搜索" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        navBackground:'#000',
        activeTextColor: "#0555b6",
        lastScrollTop: 0,
        fixedBoxTop: '0',
        hoverTimeout: null, // 悬停延迟定时器
        activeSubmenu: null, // 当前激活的子菜单索引
        submenuVisible: false, // 子菜单是否可见
      }
    },
    computed: {
      routes() {
        const flattenRoutes = (routes, parentPath = '') =>
          routes.reduce((acc, route) => {
            // 过滤掉 hidden 为 true 的菜单项
            if (route.hidden) return acc;
            const fullPath = parentPath + route.path;
            const menuItem = { ...route, path: fullPath };
            if (route.children) {
              menuItem.children = flattenRoutes(route.children, fullPath + '/');
            }
            acc.push(menuItem);
            return acc;
          }, []);
        return flattenRoutes(this.$router.options.routes)
      },
      activeIndex() {
        return this.$route.path;
      }
    },
    mounted () {
      window.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy () {
      window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
      handleSelect(key) {
        console.log(key,'222')
        this.$router.push(key).catch( () => {})
      },
      handleScroll() {
        const currentScrollTop = window.scrollY;
        if (currentScrollTop > this.lastScrollTop) {
          this.fixedBoxTop = '-200px'
        } else {
          this.fixedBoxTop = '0'
        }
        this.lastScrollTop = currentScrollTop;
      },
      getMenuTitle(route) {
        return route?.meta?.title || '网站首页'
      },
      // 判断路由是否激活
      isActiveRoute(path) {
        return this.$route.path === path || this.$route.path.startsWith(path + '/');
      },
      // 搜索功能
      handleSearch() {
        // 这里可以添加搜索逻辑，比如打开搜索弹窗或跳转到搜索页面
        console.log('搜索功能');
        // 示例：跳转到搜索页面
        this.$router.push('/home/1').catch(() => {});
      },
      // 处理菜单项鼠标进入
      handleMenuMouseEnter(index) {
        // 清除之前的定时器
        if (this.hoverTimeout) {
          clearTimeout(this.hoverTimeout);
          this.hoverTimeout = null;
        }

        // 设置当前激活的子菜单
        this.activeSubmenu = index;

        // 延迟显示子菜单，模拟Element Plus的行为
        this.hoverTimeout = setTimeout(() => {
          this.submenuVisible = true;
          // 计算并设置子菜单高度
          this.$nextTick(() => {
            this.setSubmenuHeight();
          });
        }, 100); // 100ms延迟显示
      },

      // 处理菜单项鼠标离开
      handleMenuMouseLeave() {
        console.log('菜单项鼠标离开，启动1秒延迟定时器');
        // 设置延迟隐藏，给用户时间移动到子菜单
        this.hoverTimeout = setTimeout(() => {
          console.log('1秒延迟结束，开始关闭子菜单');
          this.closeSubmenu();
        }, 1000); // 1秒延迟收起
      },

      // 处理子菜单鼠标进入
      handleSubmenuMouseEnter() {
        console.log('子菜单鼠标进入，清除延迟定时器');
        // 清除隐藏定时器，保持菜单显示
        if (this.hoverTimeout) {
          clearTimeout(this.hoverTimeout);
          this.hoverTimeout = null;
        }
        // 确保子菜单保持显示状态
        this.submenuVisible = true;
      },

      // 处理子菜单鼠标离开
      handleSubmenuMouseLeave() {
        console.log('子菜单鼠标离开，启动1秒延迟定时器');
        // 设置延迟隐藏
        this.hoverTimeout = setTimeout(() => {
          console.log('1秒延迟结束，开始关闭子菜单');
          this.closeSubmenu();
        }, 500); // 1秒延迟收起
      },

      // 关闭子菜单
      closeSubmenu() {
        console.log('开始关闭子菜单动画');
        // 先设置高度为0触发收回动画
        const submenuDrawer = this.$el.querySelector('.submenu_drawer.is-open');
        if (submenuDrawer) {
          console.log('找到子菜单元素，开始高度动画');
          submenuDrawer.style.height = '0px';

          // 监听动画完成事件
          const handleTransitionEnd = () => {
            console.log('子菜单收回动画完成');
            this.submenuVisible = false;
            this.activeSubmenu = null;
            submenuDrawer.removeEventListener('transitionend', handleTransitionEnd);
          };

          submenuDrawer.addEventListener('transitionend', handleTransitionEnd);
        } else {
          console.log('未找到子菜单元素');
          this.submenuVisible = false;
          this.activeSubmenu = null;
        }
      },

      // 设置子菜单高度
      setSubmenuHeight() {
        const submenuDrawer = this.$el.querySelector('.submenu_drawer.is-open');
        if (submenuDrawer) {
          // 先设置为auto获取实际高度
          submenuDrawer.style.height = 'auto';
          const actualHeight = submenuDrawer.offsetHeight;

          // 重置为0准备动画
          submenuDrawer.style.height = '0px';

          // 使用requestAnimationFrame确保动画正常触发
          requestAnimationFrame(() => {
            submenuDrawer.style.height = actualHeight + 'px';
          });
        }
      },

      // 调试方法：检查子菜单状态
      debugSubmenu() {
        console.log('activeSubmenu:', this.activeSubmenu);
        console.log('submenuVisible:', this.submenuVisible);
        const submenuDrawer = this.$el.querySelector('.submenu_drawer.is-open');
        if (submenuDrawer) {
          console.log('submenuDrawer height:', submenuDrawer.style.height);
          console.log('submenuDrawer offsetHeight:', submenuDrawer.offsetHeight);
        }
      },
    }
}
</script>

<style lang="scss" scoped>
.navbar_wrap {
  display: flex;
  position: fixed;
  left: 0;
  z-index: 1000;
  //height: 72px;
  height: 100px;
  width: 100%;
  background: #fff;
  transition: top 0.5s ease;
  overflow: visible;
  /* 定义CSS变量，方便子菜单定位 */
  --navbar-height: 100px;
  .navbar_container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width:1330px;
    height: 100%;
    background-color: #ffffff;
    margin: 0 auto;
    padding: 0 40px;
    .nav_left {
      cursor: pointer;
      img {
        width: 206px;
      }
    }
    .nav_right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      height: 100%;
      //margin: 20px 0;
      white-space: nowrap;
      .right_search {
        width: 24px;
        height: 24px;
        margin-left: 30px;
        img {
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
      }
    }
  }
}

/* 自定义菜单样式 */
.custom_menu {
  height: 100%;
  display: flex;
  align-items: center;
}

.menu_list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  height: 100%;
}

.menu_item {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  /* 确保子菜单可以超出父容器显示 */
  overflow: visible;
  z-index: 1001; /* 确保一级菜单在二级菜单之上 */
}

.menu_link {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 20px;
  text-decoration: none;
  color: #000;
  font-size: 18px;
  font-weight: 400;
  transition: color 0.3s ease;
  cursor: pointer;
  position: relative;
  z-index: 1002; /* 确保菜单链接在最上层 */
}

.menu_link:hover {
  color: #0555b6; /* 鼠标悬停变蓝 */
}

.menu_link.active {
  color: #0555b6;
  font-weight: 500;
}

/* 二级菜单下拉框 */
.submenu_dropdown {
  position: absolute;
  top: 100%; /* 从菜单项底部开始，无间隙 */
  left: 0;
  opacity: 0;
  visibility: hidden;
  z-index: 998; /* 进一步降低层级，确保在一级菜单之下 */
  min-width: 180px;
  /* 确保下拉框不会超出视口 */
  max-height: calc(100vh - var(--navbar-height) - 20px);
  transition: opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease; /* 添加transform过渡 */
  transform: translateY(-10px); /* 初始位置向上偏移10px */
}

/* 子菜单打开状态 */
.submenu_dropdown.is-open {
  opacity: 1;
  visibility: visible;
  transform: translateY(0); /* 移动到正常位置 */
}

/* 抽屉动画中间层 */
.submenu_drawer {
  background: linear-gradient(135deg, #667eea 0%, #263dd5 100%);
  //background: #667eea;
  border-radius: 0 0 6px 6px;
  /* 多层阴影实现扩散辐射效果 - 淡化版 */
  box-shadow:
    0 4px 15px rgba(102, 126, 234, 0.15),      /* 主阴影 */
    0 6px 25px rgba(102, 126, 234, 0.1),      /* 中层扩散 */
    0 8px 35px rgba(102, 126, 234, 0.08),     /* 外层扩散 */
    /* 左右两侧阴影 */
    -6px 0 15px rgba(102, 126, 234, 0.12),    /* 左侧阴影 */
    6px 0 15px rgba(102, 126, 234, 0.12),     /* 右侧阴影 */
    /* 底部扩散阴影 */
    0 8px 25px rgba(102, 126, 234, 0.15),     /* 底部主阴影 */
    0 12px 40px rgba(102, 126, 234, 0.1);     /* 底部扩散阴影 */
  height: 0; /* 初始高度为0 */
  overflow: hidden; /* 确保超出部分被隐藏 */
  transition: height 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94); /* 高度过渡动画 */
}

/* 抽屉打开状态 - 高度由JavaScript动态设置 */
.submenu_drawer.is-open {
  /* height 由 JavaScript 动态设置 */
}

.submenu_list {
  list-style: none;
  margin: 0;
}

.submenu_item {
  margin: 0;
}

.submenu_link {
  display: block;
  padding: 12px 20px;
  color: #ffffff;
  text-decoration: none;
  font-size: 16px;
  transition: all 0.3s ease;
  //border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.submenu_item:last-child .submenu_link {
  border-bottom: none;
}

.submenu_link:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateX(2px);
}

.submenu_link.active {
  background: rgba(255, 255, 255, 0.25);
  font-weight: 500;
}
</style>
